export const SET_VERIFY_ACCOUNT_ERROR_FROM_INBOUND = 'SET_VERIFY_ACCOUNT_ERROR_FROM_INBOUND';
export const SET_VERIFY_ACCOUNT_DONE = 'SET_VERIFY_ACCOUNT_DONE';
export function setVerifyAccountErrorFromInbound(inbound) {
    return {
        type: SET_VERIFY_ACCOUNT_ERROR_FROM_INBOUND,
        payload: inbound
    };
}
export function setVerifyAccountDone() {
    return {
        type: SET_VERIFY_ACCOUNT_DONE
    };
}
